import {NgModule} from "@angular/core";
import {Device} from "@ionic-native/device";
import {Deeplinks} from "@ionic-native/deeplinks";
import {HeaderColor} from "@ionic-native/header-color";
import {Diagnostic} from "@ionic-native/diagnostic";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {Keyboard} from "@ionic-native/keyboard";
import {FileTransfer} from "@ionic-native/file-transfer";
import {Push} from "@ionic-native/push";
import {CodePush} from "@ionic-native/code-push";
import {Calendar} from "@ionic-native/calendar";
import {PhotoViewer} from "@ionic-native/photo-viewer";
import {Geolocation} from "@ionic-native/geolocation";
import {LaunchNavigator} from "@ionic-native/launch-navigator";
import {LocationAccuracy} from "@ionic-native/location-accuracy";

@NgModule({
  providers: [
    Keyboard,
    Deeplinks,
    Keyboard,
    LaunchNavigator,
    Geolocation,
    FileTransfer,
    Push,
    HeaderColor,
    PhotoViewer,
    CodePush,
    Device,
    InAppBrowser,
    LocationAccuracy,
    Diagnostic,
    Calendar,
    InAppBrowser,
    InAppBrowser,
  ]
})
export class SellionsPluginsModule {}



// WEBPACK FOOTER //
// ./src/modules/plugins/plugins.module.ts